/**
 * Lightweight competition analytics hooks.
 * No second analytics stack — emits a CustomEvent for future adapters.
 */
export function trackCompetition(eventName, props = {}) {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent("bof:competition", {
      detail: { event: eventName, props, at: new Date().toISOString() },
    }));
  } catch (_) {
    /* ignore */
  }
}
